import React from "react";

const Card = ({ children, className = "" }) => (
  <div className={`rounded-xl border border-theme-border bg-theme-surface p-6 ${className}`}>
    {children}
  </div>
);

export default Card;
